import(/* webpackMode: "eager" */ "/usr/src/app/applicant-portal/src/app/[lang]/error.tsx")